import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { store } from "../App";

const TokenReceiver = () => {
  const [load, setLoad] = useState(false);
  const history = useHistory();
  useEffect(() => {
    //store.dispatch({ type: "SHOW_SPINNER" })
    //store.dispatch({ type: "HIDE_SPINNER" })

    const query = new URLSearchParams(window.location.search);
    const token = query.get("token");
    const username = query.get("userName");
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    setLoad(true);
  }, []);

  let user = localStorage.getItem("username");
  useEffect(() => {
    history.push("/Dashboardheader");

    // if (
    //   user.startsWith("0") ||
    //   user.startsWith("1") ||
    //   user.startsWith("2") ||
    //   user.startsWith("3") ||
    //   user.startsWith("4") ||
    //   user.startsWith("5") ||
    //   user.startsWith("6") ||
    //   user.startsWith("7") ||
    //   user.startsWith("8")
    // ) {
    //   history.push("/EAWASLogin");
    // } else if (user === "MD" || user === "SE1") {
    //   history.push("/Mddashboard");
    // } else if (
    //   user.startsWith("AE") ||
    //   user.startsWith("DEE") ||
    //   user.startsWith("EE")||
    //   user.startsWith("DH")
    // ) {
    //   history.push("/AE_DEE_EE_Login");
    // } else {
    //   history.push("/NavigationServicesHeader");
    // }
  }, [load]);
  //return load && <>Will redirect in 3 seconds...</>;

  return <>Will redirect in 3 seconds...</>;
};
export default TokenReceiver;
